/**
 * Kola's own version, independent of the rainvic-tool desktop app's — bumped
 * by kola-deploy.yml on every deploy. Since the client can ship inside the
 * desktop app on its own cadence (shared/contract.ts), the badge's tooltip
 * spells out the three versions that can now differ: this client, the server
 * it is talking to (`GET /api/auth/mode`), and the host app when embedded.
 */
import { clientVersion } from "../core/debug-log.js";
import { getHost } from "../core/host.js";
import { useServerInfo } from "../core/server-info.js";

export function VersionBadge() {
  const { serverVersion } = useServerInfo();
  const host = getHost();
  const parts = [
    `client v${clientVersion()}`,
    serverVersion === null ? null : `server v${serverVersion}`,
    host?.hostVersion === undefined ? null : `Rainvic Tool v${host.hostVersion}`,
  ].filter((part): part is string => part !== null);
  return (
    <span className="version-badge" title={parts.join(" · ")}>
      v{clientVersion()}
    </span>
  );
}
